import React from 'react'

import View from '../../../../../components/pdf/View'
import Text from '../../../../../components/pdf/Text'
import Separator from '../../../../../components/pdf/Separator'
import Image from '../../../../../components/pdf/Image'
import { Table, TableCol, TableRow } from '../../../../../components/pdf/Table'
import Grid, { Col } from '../../../../../components/pdf/Grid'
import { useReplies, useServiceOrder } from '../../_load/ServiceOrderLoader'
import {
  filterRepliesByParentReference,
  findReplyByQuestionId,
  formatDollar,
  getRepliesFromBlockQuestion,
  getReplyValue
} from '../../_helpers/pdfHelpers'
import { formatDate } from '@btime/helpers'

const AnexoCContent = () => {
  const replies = useReplies()
  const serviceOrder = useServiceOrder()

  const endDate = formatDate('DD/MM/YYYY', serviceOrder?.endDate)
  const purpose = getReplyValue(findReplyByQuestionId(replies, 255))
  const importer = getReplyValue(findReplyByQuestionId(replies, 257))
  const importerCnpj = getReplyValue(findReplyByQuestionId(replies, 259))
  const importerEmail = getReplyValue(findReplyByQuestionId(replies, 256))
  const importerPhone = getReplyValue(findReplyByQuestionId(replies, 261))
  const importerLocalDestino = getReplyValue(findReplyByQuestionId(replies, 254))?.search
  const rmVinculacao = getReplyValue(findReplyByQuestionId(replies, 260))
  const crNumber = getReplyValue(findReplyByQuestionId(replies, 258))
  const transportation = getReplyValue(findReplyByQuestionId(replies, 394))
  const shipment = getReplyValue(findReplyByQuestionId(replies, 395))
  const landing = getReplyValue(findReplyByQuestionId(replies, 396))

  const productsBlock = () => {
    const blockReply = findReplyByQuestionId(replies, 397)
    const productsReplies = filterRepliesByParentReference(replies, blockReply?.question?.reference)

    const productsResult = {}
    productsReplies.forEach(productsReply => {
      const blockIndex = productsReply.blockIndex
      let productsData = productsResult[blockIndex]

      if (!productsData) {
        const blockReplies = getRepliesFromBlockQuestion(productsReplies, blockIndex)
        const quantity = getReplyValue(findReplyByQuestionId(blockReplies, 400))
        const unitPrice = getReplyValue(findReplyByQuestionId(blockReplies, 401))
        productsData = {
          item: (blockIndex + 1).toString().padStart(2, '0'),
          description: getReplyValue(findReplyByQuestionId(blockReplies, 399)),
          quantity,
          unitPrice,
          total: quantity * unitPrice
        }
        productsResult[blockIndex] = productsData
      }
    })
    return Object.values(productsResult)
  }

  const products = productsBlock()

  return (
    <View pageBreakAfter>
      <Text bold align="center" size="h5">
        ANEXO C
      </Text>
      <Text bold align="center" size="h5">
        AUTORIZAÇÃO PRÉVIA/CERTIFICADO INTERNACIONAL DE IMPORTAÇÃO DE PCE
      </Text>
      <Separator weight={5} />
      <Table useFontBaseColor pageBreakInside>
        <TableRow useFontBaseColor>
          <TableCol bgColor={'#c0c0c0'} colspan="9" useFontBaseColor>
            <Text bold align="center">
              AUTORIZAÇÃO PRÉVIA/ CERTIFICADO INTERNACIONAL DE IMPORTAÇÃO DE PCE
            </Text>
            <Text bold align="center">
              INTERNATIONAL IMPORT CERTIFICATE
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colspan="4" width="40%">
            <Grid justify="center" align="center" direction="column">
              <Image src="/pdfs/axon/brasao-brasil.jpg" maxWidth={80} ignoreFixedSize />
              <Separator weight={2} />
              <Text align="center" size="small">
                MINISTÉRIO DA DEFESA
              </Text>
              <Text align="center" size="small">
                EXÉRCITO BRASILEIRO
              </Text>
              <Text align="center" size="small">
                COMANDO LOGÍSTICO
              </Text>
              <Text align="center" size="small">
                DIRETORIA DE FISCALIZAÇÃO DE PRODUTOS CONTROLADOS
              </Text>
            </Grid>
          </TableCol>
          <TableCol useFontBaseColor colspan="3">
            <Grid justify="center" align="center" direction="column">
              <Text>Autorização nº _________________, de</Text>
              <Separator weight={2} />
              <Text>Validade: INDETERMINADA</Text>
              <Separator weight={2} />
              <Text>Autorizo: ___________________</Text>
            </Grid>
          </TableCol>
          <TableCol useFontBaseColor colspan="2" width="20%">
            <Grid justify="center" align="center" direction="column">
              <Text align="center">Folha 1 de 1 (Editado pelo requerente)</Text>
            </Grid>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol width={3} useFontBaseColor bgColor={'#c0c0c0'} colspan="9">
            <Text bold align="center">
              IDENTIFICAÇÃO DO REQUERENTE
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor colspan="9">
          <TableCol useFontBaseColor colspan="9">
            <Text>1. Importador: {importer}</Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor colspan="9">
          <TableCol useFontBaseColor colspan="4">
            <Text>Nº CR: {crNumber}</Text>
          </TableCol>
          <TableCol useFontBaseColor style={{ borderLeft: 0 }} colspan="3">
            <Text>CPF/CNPJ: {importerCnpj}</Text>
          </TableCol>
          <TableCol useFontBaseColor style={{ borderLeft: 0 }} colspan="2">
            <Text>RM Vinculação: {rmVinculacao}</Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor colspan="9">
          <TableCol useFontBaseColor colspan="9">
            <Text>Local de destino: (Endereço Depósito): {importerLocalDestino}</Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor colspan="9">
          <TableCol useFontBaseColor colspan="4">
            <Text>Telefone: {importerPhone}</Text>
          </TableCol>
          <TableCol useFontBaseColor colspan="5">
            <Text>E-mail: {importerEmail}</Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor bgColor={'#c0c0c0'} colspan="9">
            <Text bold align="center">
              PRODUTOS AUTORIZADOS
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colspan="1" width="10%">
            <Text bold align="center">
              ITEM
            </Text>
          </TableCol>
          <TableCol useFontBaseColor colspan="5">
            <Text bold align="center">
              DESCRIÇÃO DA MERCADORIA
            </Text>
          </TableCol>
          <TableCol useFontBaseColor colspan="1" width="15%">
            <Text bold align="center">
              QUANTIDADE
            </Text>
            <Text bold align="center">
              (QUANTITY)
            </Text>
          </TableCol>
          <TableCol useFontBaseColor colspan="1" width="20%">
            <Text bold align="center">
              VALOR UNITÁRIO
            </Text>
            <Text bold align="center">
              (UNIT PRICE)
            </Text>
          </TableCol>
          <TableCol useFontBaseColor colspan="1" width="20%">
            <Text bold align="center">
              VALOR TOTAL
            </Text>
            <Text bold align="center">
              (TOTAL VALUE)
            </Text>
          </TableCol>
        </TableRow>
        {products.map((product, index) => (
          <TableRow useFontBaseColor key={index}>
            <TableCol useFontBaseColor colspan="1">
              <Text align="center">{product.item}</Text>
            </TableCol>
            <TableCol useFontBaseColor colspan="5">
              <Text>{product.description}</Text>
            </TableCol>
            <TableCol useFontBaseColor colspan="1">
              <Text align="center">{product.quantity}</Text>
            </TableCol>
            <TableCol useFontBaseColor colspan="1">
              <Text align="center">{formatDollar(product.unitPrice)}</Text>
            </TableCol>
            <TableCol useFontBaseColor colspan="1">
              <Text align="center">{formatDollar(product.total)}</Text>
            </TableCol>
          </TableRow>
        ))}
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colspan="9">
            <Text>2. Exportador / Exporter: AXON ENTERPRISE, INC, 17800 N 85th St, Scottsdale, AZ 85255 – EUA.</Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colspan="9">
            <Text>
              <b>3. Finalidade Importação/Purpose of Import:</b> {purpose}
            </Text>
            <Text>
              <b>4. Meio De Transporte / Transportation:</b> {transportation}
            </Text>
            <Text>
              <b>5. Embarque / Shipment:</b> {shipment}
            </Text>
            <Text>
              <b>6. Desembarque / Landing:</b> {landing}
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colspan="9">
            <Text>
              <b>7. Compromissos Do Importador:</b> O importador, através do seu representante legal, certifica que as
              mercadorias acima descritas não serão revendidas, desviadas, transferidas ou de qualquer modo enviadas a
              outro país, na sua forma original ou incorporadas, através de processo intermediário, em outros itens, sem
              autorização prévia da Diretoria de Fiscalização de Produtos Controlados. O importador também firma o
              compromisso de notificar imediatamente à Diretoria de Fiscalização de Produtos Controlados sobre qualquer
              modificação do que for descrito acima. Caso seja necessária uma verificação da entrega, o importador fica
              comprometido a obter e prestar as informações necessárias. QUALQUER INFORMAÇÃO FALSA, PRESTADA
              INTENCIONALMENTE NESTA DECLARAÇÃO SUJEITARÁ, O IMPORTADOR ÀS PENAS DA LEI. <br />{' '}
              <b>UNDERTAKING OF THE IMPORTER</b> <br /> The The importer, through its legal representative, hereby
              certifies that the above materials will not be resold, diverted, transferred, or otherwise sent to any
              country, either in their original form or after being incorporated, through an intermediate process, into
              other end-items, without approval of the DIRECTORY OF CONTROLLED PRODUCTS (DIRETORIA DE FISCALIZAÇÃO DE
              PRODUTOS CONTROLADOS) OF THE BRAZILIAN ARMY. The importer also undertakes to notify the Directory of
              Controlled Products about any modification in the above described. If necessary a delivery verification
              the importer undertakes to get and to present the information required. ANY FALSE STATEMENT WILLFULLY MADE
              IN THIS DECLARATION WILL SUBJECT THE IMPORTER TO LAW ENFORCEMENT.
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colspan="9">
            <Text>
              <b>8. CERTIFICAÇÃO/CERTIFICATION:</b> Fica certificado que a declaração acima foi apresentada à DIRETORIA
              DE FISCALIZAÇÃO DE PRODUTOS CONTROLADOS DO EXÉRCITO BRASILEIRO, e que o importador está autorizado a
              importar para o Brasil as mercadorias acima relacionadas. / This is to certify that the above declaration
              has been presented to the DIRECTORY OF CONTROLLED PRODUCTS (DIRETORIA DE FISCALIZAÇÃO DE PRODUTOS
              CONTROLADOS) OF THE BRAZILIAN ARMY and the importer is authorized to import into Brazil the listed
              materials.
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colspan="4">
            <Grid justify="center" align="center" direction="column">
              <Col>
                <Separator weight={20} />
                <Text align="center">{endDate}</Text>
                <Text align="center">Data de assinatura</Text>
                <Text align="center">(Date of Signature)</Text>
              </Col>
            </Grid>
          </TableCol>
          <TableCol useFontBaseColor colspan="5">
            <Grid justify="center" align="center" direction="column">
              <Separator weight={20} />

              <Text>______________________________________________________________________</Text>
              <Text>Assinatura do importador ou Representante Legal</Text>
              <Text>(Signature of the importer or legal representative)</Text>
            </Grid>
          </TableCol>
        </TableRow>
      </Table>
    </View>
  )
}

export default AnexoCContent
